import { IUser } from '../models/MainLayout/User';
import { api } from 'boot/axios';
import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    user: null as IUser | null,
    returnUrl: null as string | null,
    loginType: null as string | null
  }),
  getters: {
    userRole:() => {
      return 'User';
    },
    sogapaAdminRole:() => {
      return 'SogapaAdministrator';
    },
    adminRole:() => {
      return 'Administrator';
    },
    isAuthenticated: (state) => state.user?.isAuthenticated ?? false,
    userName: (state) => state.user?.name ?? '',
    isSogapaAdmin: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('SogapaAdministrator') >= 0;
      }

      return false;
    },
    isAdmin: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('Administrator') >= 0;
      }

      return false;
    },
    isUser: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('User') >= 0;
      }

      return false;
    },
    isRegisterFirstCommunion: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('RegisterFirstCommunion') >= 0;
      }

      return false;
    },
    isRegisterConfirmation: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('RegisterConfirmation') >= 0;
      }

      return false;
    },
    isServiceAttendance: (state) => {
      const user = state.user;
      if (user)
      {
        return user.roles?.indexOf('ServiceAttendance') >= 0;
      }

      return false;
    }
  },
  actions: {
    async loadUser() {
      if (this.user == null) {
        const userResponse = await api.get<IUser>('/api/account/whoami');
        this.user = userResponse.data;
      }
    },
    async reloadUser() {
      const userResponse = await api.get<IUser>('/api/account/whoami');
      this.user = userResponse.data;
    },
    setReturnUrl(url: string | null) {
      this.returnUrl = url;
    },
    setLoginType(type: string | null) {
      this.loginType = type;
    }
  },
});
